<template>
  <div class="list">
    <b-row class="columns pb-10">
      <b-col class="col-3 pl-68 title">NAME</b-col>
      <b-col class="col-3 title">EMAIL</b-col>
      <b-col class="col-3 title pl-48" v-if="role !== 'pi'">ROLE</b-col>
      <b-col class="col-3 title" :class="{ mrblinded: role === 'pi' }">BLINDED</b-col>
    </b-row>
    <div class="row-data pt-12 pb-15">
      <div id="container" :class="{ scroll: filteredMemberLists.length > 6 }">
        <b-row
          v-for="(member, index) in filteredMemberLists"
          :key="index"
          class="single-row"
          :class="{
            selected: selectedMember && member.id === selectedMember.id
          }"
          :id="'selected-' + member.id"
        >
          <b-col cols="3">
            <input type="radio" name="PI" class="custom-control custom-radio custom-control-inline" :checked="selectedMember && member.id === selectedMember.id" v-if="role == 'pi'" v-model="selectedMember" :value="member" />
            <input type="checkbox" class="custom-control custom-radio custom-control-inline" v-if="role !== 'pi'" v-model="selectedTeam" :value="member" />
            <span class="img-wrapper mt-5 mr-20"><img src="/static/img/profile.png"/></span>
            <span class="name-column"
              ><b>{{ member.firstName }} {{ member.lastName }}</b></span
            >
          </b-col>
          <b-col cols="3" class="pt-6 word-break pr-10">{{ member.username }}</b-col>
          <b-col cols="3" class="pt-6 pl-67" v-if="role !== 'pi'">{{ userRole[member.userRole] }}</b-col>
          <b-col cols class="pt-6" :class="{ mrblinded: role === 'pi' }">
            <div class="site-pi-add">
              <span class="un-bld-Lbl-Txt">Unblinded</span>
              <label class="switch cursor_pointer">
                <input type="checkbox" v-model="member.blinded" />
                <div class="slider round" :class="{ checked: member.blinded }"></div>
              </label>
              <span class="bld-Lbl-Txt">Blinded</span>
              <span class="info-msg">
                <i
                  class="fa fa-info-circle help_icon cursor_pointer overflow-info"
                  aria-hidden="true"
                  data-toggle="popover"
                  tabindex="0"
                  data-trigger="focus"
                  data-content="Toggling the member as <b>Blinded</b> will hide sensitive participant
                   information for this  member. <b>Unblinded</b> will show all participant information allowed
                   for this role.
                  "
                  data-html="true"
                ></i>
              </span>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <div class="new-pi-added pt-25" v-if="listIsVisible">
      <div class="title" v-if="role == 'pi'">
        If the PI is not in the list above, invite a new PI to join.
      </div>
      <div class="title" v-else>
        If the person is not in the list above, invite a new person to join.
      </div>
      <b-row class="form-card">
        <b-col cols="4">
          <div class="btn-wrapper-2" @click="createNewParticipant()">
            <i class="fa fa-plus"></i>
            <span class="cursor_pointer">
              <span class="btn-text">Add New</span>
            </span>
          </div>
        </b-col>
        <b-col cols="8" class="with-list">
          <div class="submit-btn pull-right">
            <button class="btn btn-primary" :disabled="selectedMember == null && selectedTeam.length == 0" @click="saveSiteTeam()">
              Add
            </button>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import toastr from "toastr";
import _ from "lodash";
import $ from "jquery";

export default {
  name: "list-of-members",
  data() {
    return {
      columns: [],
      selectedMember: null,
      selectedTeam: [],
      filteredMemberLists: [],
      userRole: {
        Pi: "Principal Investigator",
        SubPi: "Sub-Investigator",
        StudyCoordinator: "Study Coordinator",
        HomeHealth: "Home Health",
        SiteDataLock: "Site - Data Lock",
        Rater: "Rater",
        CallCenter: "Call Center"
      }
    };
  },
  props: {
    memberList: {
      type: Array,
      default: () => {}
    },
    role: {
      type: String,
      default: "pi"
    },
    listIsVisible: {
      type: Boolean,
      default: true
    },
    selectedSiteTeam: {}
  },
  computed: {},
  watch: {
    selectedSiteTeam: {
      immediate: true,
      handler(val) {
        if (val.length > 0) {
          this.selectedTeam = val;
        }
      }
    },
    memberList: {
      immediate: true,
      handler(val) {
        if (val.length > 0) {
          this.filteredMemberLists = _.cloneDeep(val);
          if (this.selectedTeam.length > 0) {
            this.filteredMemberLists = this.filteredMemberLists.map(obj => this.selectedTeam.find(o => o.id === obj.id) || obj);
          }
        }
      }
    }
  },
  components: {},
  methods: {
    scrollElement() {
      const container = $("#container");

      const scrollTo = $("#selected-" + this.selectedMember.id);
      container.animate({
        scrollTop: scrollTo.offset().top - container.offset().top + container.scrollTop()
      });
    },
    createNewParticipant() {
      this.$emit("switchView", this.listIsVisible, this.selectedTeam);
    },
    saveSiteTeam() {
      if (this.role == "pi") {
        this.$emit("saveSitePI", this.selectedMember);
      } else {
        const piCount = this.selectedTeam.filter(item => item.userRole == "Pi").length;
        if (piCount > 1) {
          toastr.error("Do not select multiple PI");
          return;
        }
        this.$emit("saveSiteTeamMember", this.selectedTeam);
        this.selectedTeam = [];
      }
    }
  },
  mounted() {
    $(document).ready(function() {
      $('[data-toggle="popover"]').popover();
    });
    this.$root.$on("showActiveParticipantList", () => {
      const self = this;
      setTimeout(() => {
        self.listIsVisible = true;
        if (self.selectedMember && this.role == "pi") {
          self.scrollElement();
        }
      }, 100);
    });
    this.$root.$on("memberDeleted", data => {
      // only for pi because it is not a reference holding
      // not need to handle for team role
      if (data.member == "pi") {
        this.selectedMember = null;
      }
    });
    this.$root.$on("resetAllTheValues", () => {
      this.selectedTeam = [];
      this.selectedMember = null;
    });
    this.$root.$on("restoreMember", data => {
      if (data.role == "pi") {
        this.selectedMember = data.member;
      } else {
        this.selectedMember = data.member;
      }
    });
  }
};
</script>

<style lang="scss" scoped>
/deep/ .custom-control {
  vertical-align: middle;
}
.img-wrapper {
  display: inline-block;
  width: 30px;
  height: 35px;
  img {
    width: 100%;
  }
}
.title {
  color: #666669;
  font-size: 10px;
  opacity: 0.7;
}
.row-data {
  background-color: #f5f8fa;
  #container {
    max-height: 441px;
  }
}
.single-row {
  padding: 7px;
  border-radius: 3px;
  box-shadow: 0 1px 0px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px #d3dfe4;
  background-color: #fff;
  margin-bottom: 12px;
  margin-right: 20px !important;
  &.selected {
    background-color: #eef4fd;
  }
}
.row-data {
  font-family: Roboto-Regular;
  font-size: 14px;
  line-height: 1.43;
  color: #666669;
  .scroll {
    margin-right: 10px;
    overflow-y: scroll;
    //Scrollbar CSS for Mozilla
    overflow-y: scroll;
    scrollbar-color: #c4c4c4 #fff; /* thumb and track color */
    scrollbar-width: thin;
    //Below is the scrollbar css for Chrome
    &::-webkit-scrollbar {
      width: 9px;
      background-color: #fff;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #c4c4c4;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-track {
      background-color: #fff;
    }
  }
}
/* The slider */
.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 23px;
  top: 6px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #ccc;
  pointer-events: none;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #ccc;
}
.checked.slider {
  border: 2px solid #48bf7a;
}
.checked.slider:before {
  content: "";
  background-color: #48bf7a;
}
.checked.slider:before {
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}
/* Hide default HTML checkbox */
.switch input {
  display: none;
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
/* Rounded sliders */
.un-bld-Lbl-Txt {
  color: #666669 !important;
  opacity: 0.5;
  position: relative;
  top: -8px;
  right: 10px;
}
.bld-Lbl-Txt {
  color: #666669 !important;
  opacity: 0.5;
  position: relative;
  top: -8px;
  left: 5px;
}
.help_icon {
  color: #b8c7ce;
  border: none !important;
  outline: none !important;
}
.info-msg {
  position: relative;
  left: 10px;
  top: -8px;
}
.site-mem-add {
  position: relative;
  bottom: 20px;
  right: 10px;
}
.site-pi-add {
  position: relative;
  bottom: 5px;
  left: 8px;
}
.site-pi-lock {
  position: relative;
  bottom: 5px;
  left: 2px;
  height: 50px;
}
.info-msglock {
  position: relative;
  top: 14px;
  right: 5px;
}
.siteteam-info {
  position: relative;
  right: 15px;
}
.removelink {
  position: relative;
  left: 40px;
}
//@at-root
.new-pi-added {
  .title {
    color: #000;
    padding-left: 15px;
    padding-bottom: 12px;
    font-size: 14px;
    font-weight: 600;
  }
  .fields {
    .header-text {
      color: #666669 !important;
      opacity: 0.5;
      font-size: 14px;
    }
    input {
      font-size: 12px;
    }
    .submit-btn {
      .btn-primary {
        position: relative;
        top: 17px;
        width: 100px;
        border-radius: 25px;
        right: 22px;
        background: #4c8ce4;
      }
    }
  }
  .with-list {
    &.col-8 {
      max-width: 64.666667%;
    }
    .submit-btn {
      .btn-primary {
        padding: 6px 35px;
        border-radius: 25px;
        background: #4c8ce4;
      }
    }
  }
}
.name-column {
  width: 85px;
  display: inline-block;
  vertical-align: middle;
}
.word-break {
  word-break: break-word;
}
.overflow-info {
  overflow: visible;
}
.btn-wrapper-2 {
  border-radius: 3px;
  border: 1.5px solid #c5d1d6;
  width: 96px;
  padding: 2px 2px;
  position: relative;
  cursor: pointer;
  .fa-plus {
    border: 1px solid #b0bac9;
    padding: 2px 3px;
    border-radius: 3px;
    background: #b0bac9;
    color: #fff;
  }
  .btn-text {
    padding-left: 10px;
    color: #4c8ce4;
    font-family: Roboto-Regular;
    font-size: 14px;
  }
}
.mrblinded {
  margin-left: 80px !important;
}
.pl-67 {
  padding-left: 67px !important;
}
.pl-48 {
  padding-left: 48px !important;
}
</style>
